/**
 * GLOBALS.JS
 *
 * Global user-specific constants to be used for more than one module.
 */

// Enables the switch between standard and inverted headermenu
export const ENABLE_TRANSPARENT_HEADER = false;
// Enables the navigation item highlighting based on anchorlinks
export const ENABLE_HIGHLIGHTED_NAVIGATION = false;
// Enables dropdown menu in header menu
export const ENABLE_DROPDOWN_MENU = true;

/**
 * Converts size value from 'rem' to 'px'.
 * @param remValue size in 'rem'
 * @returns {number} size in 'px'
 */
export const convertRemToPixels = (remValue) => {
	return remValue * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

/*
	SCREEN BREAKPOINT GLOBALS
    These should be set accordingly to the screen breakpoints in tailwind.config.js
 */
export const BREAKPOINT_XS = convertRemToPixels(30);
export const BREAKPOINT_SM = convertRemToPixels(40);
export const BREAKPOINT_MD = convertRemToPixels(48);
export const BREAKPOINT_LG = convertRemToPixels(64);
export const BREAKPOINT_XL = convertRemToPixels(80);
export const BREAKPOINT_2XL = convertRemToPixels(96);
